import React, {useState, useEffect, useCallback, useRef} from 'react';
import {GoogleMap, useLoadScript} from "@react-google-maps/api"
import {Link} from 'react-router-dom';
import axios from 'axios';

const libraries = ['places'];
const mapContainerStyle = {
    height: '60vh',
    width: '100%'
}

const options = {
    disableDefaultUI:true,
    zoomControl:true
}
function MuseumMap(){

    const[maps, setMaps] = useState([])
    
    const[id, setId] = useState('')

    useEffect(()=>{
        getMap()
    }, []);

    const {isLoaded, loadError} = useLoadScript({
        googleMapsApiKey:id,
        libraries,
    });

    const mapRef = useRef();
    const onMapLoad = useCallback((map)=>{
        mapRef.current = map;
    },[]);

    if(loadError) return 'Error';
    if(!isLoaded) return 'Loading...';

    function getMap(){
        axios.get('/api/map_museum')
        .then(response=>{
            setId(response.data.id)
            const data = response.data.data;

        })
        .catch(err=>{
            console.log(err)
        })
    }
    return(
        <div>
            <p>Map Area</p>
            <GoogleMap
            id='map'
            mapContainerStyle={mapContainerStyle}
            zoom={8}
            center={{
                lat: 43.048225,
                lng: 141.49701,
            }}
            options={options}
            onLoad={onMapLoad}
            >

            </GoogleMap>
            <Link to='/museums/list'>to List</Link>
        </div>
    )
}

export default MuseumMap;